import moment from 'moment';
import { Formik } from 'formik';

import FormWrapper from '~FormWrapper';
import SpaceRequestForm from './SpaceRequestForm';

import { usePatientAndOperatingRooms } from '~hooks/usePatientAndOperatingRooms';
import { useOnSubmit, useOnEdit } from '~hooks';

import { removeEmptyKeys } from '../validations';

const SpaceRequest = props => {
  const { formId, edit } = props;

  const rooms = usePatientAndOperatingRooms();

  // const phone = useSelector(state => state.user?.data?.phone);

  const validate = values => {
    const errors = {};

    if (!values.requestType) {
      errors.requestType = 'Vaadittu';
    }

    if (values.requestType === 'NEW_ROOM') {
      if (!values.newRoomUsage) {
        errors.newRoomUsage = 'Vaadittu';
      }

      if (!values.newRoomDescription) {
        errors.newRoomDescription = 'Vaadittu';
      }

      if (!values.newRoomCostCenter) {
        errors.newRoomCostCenter = 'Vaadittu';
      }

      if (!values.newRoomAdditionalInfo) {
        errors.newRoomAdditionalInfo = 'Vaadittu';
      }

      if (!values.newRoomEmail) {
        errors.newRoomEmail = 'Vaadittu';
      }

      if (!values.newRoomPhone) {
        errors.newRoomPhone = 'Vaadittu';
      }

      if (!values.newRoomDate) {
        errors.newRoomDate = 'Vaadittu';
      }

      if (!values.newRoomPermission) {
        errors.newRoomPermission = 'Vaadittu';
      }
    }

    if (values.requestType === 'CHANGE_ROOM') {
      if (!values.changeRoomSpace) {
        errors.changeRoomSpace = 'Vaadittu';
      }

      if (!values.changeRoomUsage) {
        errors.changeRoomUsage = 'Vaadittu';
      }

      if (!values.changeRoomDescription) {
        errors.changeRoomDescription = 'Vaadittu';
      }

      if (
        values.changeRoomCostCenterChange &&
        !values.changeRoomNewCostCenter
      ) {
        errors.changeRoomNewCostCenter = 'Vaadittu';
      }

      if (!values.changeRoomAdditionalInfo) {
        errors.changeRoomAdditionalInfo = 'Vaadittu';
      }

      if (!values.changeRoomEmail) {
        errors.changeRoomEmail = 'Vaadittu';
      }

      if (!values.changeRoomPhone) {
        errors.changeRoomPhone = 'Vaadittu';
      }

      if (!values.changeRoomDate) {
        errors.changeRoomDate = 'Vaadittu';
      }

      if (!values.changeRoomPermission) {
        errors.changeRoomPermission = 'Vaadittu';
      }
    }

    if (values.requestType === 'CHANGE_PAYER') {
      if (!values.changePayerSpace) {
        errors.changePayerSpace = 'Vaadittu';
      }

      if (!values.changePayerNewCostCenter) {
        errors.changePayerNewCostCenter = 'Vaadittu';
      }

      if (!values.changePayerDescription) {
        errors.changePayerDescription = 'Vaadittu';
      }

      if (!values.changePayerEmail) {
        errors.changePayerEmail = 'Vaadittu';
      }

      if (!values.changePayerPhone) {
        errors.changePayerPhone = 'Vaadittu';
      }

      if (!values.changePayerDate) {
        errors.changePayerDate = 'Vaadittu';
      }
    }

    if (values.requestType === 'TERMINATION') {
      if (!values.terminateSpace) {
        errors.terminateSpace = 'Vaadittu';
      }

      if (!values.terminateDescription) {
        errors.terminateDescription = 'Vaadittu';
      }

      if (!values.terminatePayerEmail) {
        errors.terminatePayerEmail = 'Vaadittu';
      }

      if (!values.terminatePayerPhone) {
        errors.terminatePayerPhone = 'Vaadittu';
      }

      if (!values.terminatePayerDate) {
        errors.terminatePayerDate = 'Vaadittu';
      }

      if (!values.terminatePayerAcceptance) {
        errors.terminatePayerAcceptance = 'Vaadittu';
      }

      if (!values.terminatePermission) {
        errors.terminatePermission = 'Vaadittu';
      }
    }

    return removeEmptyKeys(errors);
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={{
        requestType: null,

        newRoomOffice: null,
        newRoomBuilding: null,
        newRoomUsage: '',
        newRoomDescription: '',
        newRoomCostCenter: null,
        newRoomParking: false,
        newRoomAccessibility: false,
        newRoomAdditionalInfo: '',
        newRoomEmail: '',
        newRoomPhone: '',
        newRoomDate: moment(),
        newRoomPermission: false,

        changeRoomSpace: null,
        changeRoomUsage: '',
        changeRoomDescription: '',
        changeRoomCostCenterChange: false,
        changeRoomNewCostCenter: null,
        changeRoomParking: false,
        changeRoomAccessibility: false,
        changeRoomAdditionalInfo: '',
        changeRoomEmail: '',
        changeRoomPhone: '',
        changeRoomDate: moment(),
        changeRoomPermission: false,

        changePayerSpace: null,
        changePayerNewCostCenter: null,
        changePayerDescription: '',
        changePayerEmail: '',
        changePayerPhone: '',
        changePayerDate: moment(),

        terminateSpace: null,
        terminateDescription: '',
        terminateAdditionalInfo: '',
        terminatePayerEmail: '',
        terminatePayerPhone: '',
        terminatePayerDate: moment(),
        terminatePayerAcceptance: false,
        terminatePermission: false,
      }}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            // Async select doesn't support the SelectIdField component because
            // it can't read `options` from props
            newRoomBuilding: values.newRoomBuilding?.value,
          },
          setSubmitting,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Tilapyynnöt"
          formik={formikProps}
          Component={SpaceRequestForm}
          rooms={rooms}
        />
      )}
    </Formik>
  );
};

export default SpaceRequest;
